import { render } from "./BannerComp.vue?vue&type=template&id=eb0a8236"
import script from "./BannerComp.vue?vue&type=script&lang=js"
export * from "./BannerComp.vue?vue&type=script&lang=js"

import "./BannerComp.vue?vue&type=style&index=0&id=eb0a8236&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__